// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import uuidv4 from 'uuid/v4';
import { Link } from 'react-router-dom';

import * as parcelShopsActions from '../../pages/find-parcel-shop/store/actions';
import { getParcelShops, getPostcode } from '../../pages/find-parcel-shop/store/selectors';
import { getAddress } from
  '../../pages/account/components/AccountTab/components/MyProfile/store/selectors';
import * as profileActions from
  '../../pages/account/components/AccountTab/components/MyProfile/store/actions';
import Button from '../Button/Button';
import Input from '../Input/Input';
import { MyMap } from '../../pages/choose-delivery/components';
import styles from './styles';

class PostcodeWithMap extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    parcelShops: PropTypes.array,
    postcode: PropTypes.string,
    address: PropTypes.object,
    changeField: PropTypes.func,
    requestParcelShops: PropTypes.func,
    requestProfile: PropTypes.func,
    setPostcode: PropTypes.func,
    isInOrderLite: PropTypes.bool,
  };

  static defaultProps = {
    classes: {},
    parcelShops: [],
    postcode: null,
    address: {},
    changeField: () => { },
    requestParcelShops: () => { },
    requestProfile: () => { },
    setPostcode: () => { },
    isInOrderLite: false,
  };

  componentDidMount() {
    const customerId = localStorage.getItem('loggedID');
    const token = localStorage.getItem('token');
    this.props.requestProfile(customerId, token);
    this.props.setPostcode(this.props.address.Postcode ? this.props.address.Postcode : null);
  }

  searchParcelShops = () => {
    const { requestParcelShops, postcode } = this.props;
    requestParcelShops(postcode);
  }

  render() {
    const {
      classes,
      parcelShops,
      postcode,
      isInOrderLite,
    } = this.props;

    const text = [{
      text: 'To find your nearest ',
      bold: false,
    }, {
      text: 'Evri',
      bold: true,
    }, {
      text: ` drop off point enter your postcode in the field below,
      if you can't find a Evri near to you, please  `,
      bold: false,
    }, {
      text: 'contact us.',
      bold: true,
      link: '/contact',
    }];

    return (
      <div>
        <div className={
          isInOrderLite
            ? classes.descriptionOrdersContainer
            : classes.descriptionContainer}
        >
          {text.map(el => (
            <span
              key={uuidv4()}
              className={classNames(classes.text,
                el.bold ? classes.boldText : null)}
            >
              {!el.link ? el.text : <Link className={classes.link} to={el.link}>{el.text}</Link>}
            </span>))}
        </div>
        <div className={classes.postcodeContainer}>
          <Input
            placeholder={'Postcode'}
            value={postcode}
            name={'postcode'}
            onChange={this.props.changeField}
          />
          <Button
            text={'SEARCH'}
            onPress={this.searchParcelShops}
          />
        </div>
        <MyMap shops={parcelShops} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    postcode: getPostcode(state),
    parcelShops: getParcelShops(state),
    address: getAddress(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeField: (value, name) => dispatch(parcelShopsActions.changeField(value, name)),
    requestParcelShops: postcode => dispatch(parcelShopsActions.getParcelShops(postcode)),
    requestProfile: (id, token) => dispatch(profileActions.requestProfile(id, token)),
    setPostcode: postcode => dispatch(parcelShopsActions.setPostcode(postcode)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PostcodeWithMap));
